export function resolveEnumerationValue(data: unknown) {
  if (typeof data === "string") {
    const trimmed = data.trim();
    return trimmed || null;
  }

  if (Array.isArray(data)) {
    for (const item of data) {
      const resolved = resolveEnumerationValue(item);
      if (resolved) {
        return resolved;
      }
    }

    return null;
  }

  if (data && typeof data === "object") {
    const record = data as Record<string, unknown>;
    const candidates = [
      record.value,
      record.Value,
      record.url,
      record.Url,
      record.imageUrl,
      record.ImageUrl,
      record.parameter,
      record.Parameter,
      record.name,
      record.Name,
    ];

    for (const candidate of candidates) {
      if (typeof candidate === "string" && candidate.trim()) {
        return candidate.trim();
      }
    }
  }

  return null;
}
